// © Microsoft Corporation. All rights reserved.

import { logger } from "@msnews/diagnostics";

export function dispatchBridgeEvent(bridgeEventName, data = {}) {
    try {
        document.dispatchEvent(new CustomEvent(bridgeEventName, {detail: {eventName: bridgeEventName, data: data}}));
    } catch (e) {
        logger.logError(e);
    }
}

export const BridgeEventNames = {
    signInClicked: "sign-in-clicked",
    saveCachedMyReaction: "save-cached-my-reaction",
    openPopup: "open-popup",
    closePopup: "close-popup"
};